<script>
  import Button from '@components/buttons/button.svelte'
  import ImagePreview from '@components/general/image-preview.svelte'
  import FileIcon from '@components/general/file-icon.svelte'
  import { Download } from 'lucide-svelte'
  import { filesize } from 'filesize'
  
  let { file, fallback = "-" } = $props()

  let previewOpen = $state(false)
  let previewable = $derived(file?.content_type?.startsWith('image/'))

  function openPreview() {
    if (!previewable) return
    previewOpen = true
  }

  function downloadFile() {
    window.open(file.url, "_blank")
  }
</script>

{#if file}
  <div class="flex items-start gap-2">
    <FileIcon {file} />
    <div class="flex flex-col gap-1">
      <Button variant="naked" text={file.name} onclick={previewable ? openPreview : null} class={previewable ? "hover:underline" : ""} />
      <div class="flex items-center gap-1 text-[11px] text-gray-500/80">
        <span class="leading-none uppercase">{file.extension}</span>
        <span class="leading-none">{filesize(file.byte_size)}</span>
        <Button variant="naked" Icon={Download} onclick={downloadFile} hint="Download file" class="text-gray-500 hover:text-gray-700" iconProps={{ size: 12 }} />
      </div>
    </div>
  </div>
{:else}
  <span>{fallback}</span>
{/if}

{#if previewable}
  <ImagePreview src={file.url} bind:open={previewOpen} />
{/if}